var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottery-draw-sidebar"},[_c('section',{staticClass:"next-draw-wrapper"},[_c('NextDrawInfo')],1),_c('section',{staticClass:"sidebar-statistics-wrapper"},[_c('Statistics',{attrs:{"in-draw":"","is-drawn-type":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }